/**
 * Creates a generic tracker for us to use in react-track / framework context
 *
 * @author Nick Dreckshage <ndreckshage@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
/* eslint-env browser */

import createTracker from './create-tracker';
export default createTracker;
